import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ModalContentContainer } from './styles';
import BasicModal from '__components/Modals/presets/BasicModal';
import { Description } from 'pages/Common/components/Description';
import { Automation } from 'store/automationsPage/automations.redux';

type EditDescriptionPayload = {
  id: string;
  userDescription: string;
};

type EditFolderModalProps = {
  automation: Automation;
  onConfirm(data: EditDescriptionPayload): Promise<void>;
  onHide(): void;
};

export const EditDescriptionModal = ({
  automation,
  onConfirm,
  onHide,
}: EditFolderModalProps) => {
  const { t } = useTranslation();
  const [userDescription, setUserdescription] = useState(
    automation.userDescription || ''
  );
  const handleChangeDescription = useCallback(
    (value: any) => {
      const trimmed = value.trim();
      setUserdescription(trimmed);
    },
    [setUserdescription]
  );

  return (
    <BasicModal
      show
      heading={t('Edit Description')}
      onHide={onHide}
      onConfirm={async () => {
        await onConfirm({
          id: automation.id,
          userDescription,
        });
      }}
      forceFocus={false}
      size="medium"
    >
      <ModalContentContainer>
        <Description
          label={t('Agentic Workflow Description')}
          description={userDescription}
          aiDescription={automation.aiDescription || ''}
          onChange={handleChangeDescription}
          inputProps={{
            fixedHeight: '200',
            fullHeight: true,
          }}
        />
      </ModalContentContainer>
    </BasicModal>
  );
};
